import { defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "row pt-3",
  style: {"border-top":"1px dashed rgba(106, 113, 133, 0.3)"}
}
const _hoisted_2 = { class: "col-sm-6" }
const _hoisted_3 = { class: "mt-3 checkbox-checked h-100 d-flex h-100 align-items-center" }
const _hoisted_4 = { class: "form-check" }
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "input-group" }
const _hoisted_7 = { class: "col-sm-6" }
const _hoisted_8 = { class: "input-group" }
const _hoisted_9 = { class: "col-sm-6" }
const _hoisted_10 = { class: "input-group" }

import { computed, reactive, watch, onMounted } from 'vue'
import { useProductsStore } from '@/store/management/productsStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'productScale',
  setup(__props) {

const productStore = useProductsStore()

onMounted(() => {
    if (tempActiveProduct.value?.basic.productNumber) {
        const productGroup = tempActiveProduct.value
        const scaleData = productGroup.scale
        compState.scaleItem = scaleData.scaleItem
        compState.weightDecimalPlaces = scaleData.weightDecimalPlaces
        compState.scaleMultiplier = scaleData.scaleMultiplier
        compState.tare = scaleData.tare
    }
})

const compState = reactive({
    scaleItem: false,
    weightDecimalPlaces: 0,
    scaleMultiplier: 0,
    tare: 0
})


const activeProduct = computed(() => {
    return productStore.getActiveProduct
})

const tempActiveProduct = computed(() => {
    return productStore.getTempActiveProduct
})

const activeProductId = computed(() => {
    return productStore.getActiveProductId
})

watch(activeProductId, (newVal) => {
    if (newVal) {
        const productGroup = activeProduct.value
        const scaleData = productGroup.scale
        compState.scaleItem = scaleData.scaleItem
        compState.weightDecimalPlaces = scaleData.weightDecimalPlaces
        compState.scaleMultiplier = scaleData.scaleMultiplier
        compState.tare = scaleData.tare
    }
}, { immediate: true });

watch(compState, (newVal) => {
    productStore.setTempActiveProduct({
        ...tempActiveProduct.value,
        scale: {
            scaleItem: newVal.scaleItem,
            weightDecimalPlaces: newVal.weightDecimalPlaces,
            scaleMultiplier: newVal.scaleMultiplier,
            tare: newVal.tare
        }
    })

}, { deep: true });

const weightDecimalPlacesDecrement = () => {
    compState.weightDecimalPlaces++
}

const weightDecimalPlacesIncrement = () => {
    if (compState.weightDecimalPlaces > 0) {
        compState.weightDecimalPlaces--
    }
}
const scaleMultiplierDecrement = () => {
    compState.scaleMultiplier++
}

const scaleMultiplierIncrement = () => {
    if (compState.scaleMultiplier > 0) {
        compState.scaleMultiplier--
    }
}
const tareDecrement = () => {
    compState.tare++
}

const tareIncrement = () => {
    if (compState.tare > 0) {
        compState.tare--
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            id: "scaleItem",
            type: "checkbox",
            value: "",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((compState.scaleItem) = $event))
          }, null, 512), [
            [_vModelCheckbox, compState.scaleItem]
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("label", {
            class: "form-check-label",
            for: "scaleItem"
          }, "Scale Item", -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[5] || (_cache[5] = _createElementVNode("label", null, [
        _createElementVNode("h6", { class: "f-w-700" }, "Stock Low Watermark")
      ], -1)),
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          type: "number",
          placeholder: "Threshold",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((compState.weightDecimalPlaces) = $event))
        }, null, 512), [
          [_vModelText, compState.weightDecimalPlaces]
        ]),
        _createElementVNode("button", {
          class: "btn btn-outline-secondary rounded-end-0",
          type: "button",
          onClick: weightDecimalPlacesDecrement
        }, "-"),
        _createElementVNode("button", {
          class: "btn btn-outline-secondary rounded-start-0",
          type: "button",
          onClick: weightDecimalPlacesIncrement
        }, "+")
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[6] || (_cache[6] = _createElementVNode("label", null, [
        _createElementVNode("h6", { class: "f-w-700" }, "Stock High Watermark")
      ], -1)),
      _createElementVNode("div", _hoisted_8, [
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          type: "number",
          placeholder: "Threshold",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((compState.scaleMultiplier) = $event))
        }, null, 512), [
          [_vModelText, compState.scaleMultiplier]
        ]),
        _createElementVNode("button", {
          class: "btn btn-outline-secondary rounded-end-0",
          type: "button",
          onClick: scaleMultiplierDecrement
        }, "-"),
        _createElementVNode("button", {
          class: "btn btn-outline-secondary rounded-start-0",
          type: "button",
          onClick: scaleMultiplierIncrement
        }, "+")
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _cache[7] || (_cache[7] = _createElementVNode("label", null, [
        _createElementVNode("h6", { class: "f-w-700" }, "Sale to Stock Unit Ratio")
      ], -1)),
      _createElementVNode("div", _hoisted_10, [
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          type: "number",
          placeholder: "Threshold",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((compState.tare) = $event))
        }, null, 512), [
          [_vModelText, compState.tare]
        ]),
        _createElementVNode("button", {
          class: "btn btn-outline-secondary rounded-end-0",
          type: "button",
          onClick: tareDecrement
        }, "-"),
        _createElementVNode("button", {
          class: "btn btn-outline-secondary rounded-start-0",
          type: "button",
          onClick: tareIncrement
        }, "+")
      ])
    ])
  ]))
}
}

})